import React, { useEffect } from 'react';
import { Dropdown, Checkbox, Loader } from '../../../../components';
import { useSelector, useDispatch } from 'react-redux';
import {
	toggleFilterSections,
	getFilterClasses,
	setFilterClass,
	resetFilterSelectedSubjects,
	resetFilterSelectedTopics,
} from '../../../../redux/actions';

const Classes = () => {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	const filter = state.filter;
	const selected = filter.selected;

	useEffect(() => {
		if (selected.level) {
			dispatch(getFilterClasses(selected.level));
		}
	}, [selected.level, dispatch]);

	return (
		<Dropdown
			title="Klasa"
			name="classes"
			className="classes-dropdown"
			isOpen={state.filter.activeSections.indexOf('classes') !== -1}
			onClick={() => dispatch(toggleFilterSections('classes'))}
			selected={selected.classes.length > 0 && `Klasa ${selected.classes.sort().join(',')}`}
		>
			<ul className="dropdown-list">
				{state.filter.loadingSections.includes('classes') ? (
					<li className="loader-container">
						<Loader type="ellipsis" />
					</li>
				) : filter.classes[selected.level] ? (
					filter.classes[selected.level].map((singleClass) => (
						<li className="dropdown-list-item" key={`class-${singleClass.klasa}`}>
							<Checkbox
								id={singleClass.id}
								label={`${singleClass.klasa} klasa`}
								checked={selected.classes.includes(singleClass.klasa)}
								onChange={() => {
									dispatch(resetFilterSelectedSubjects());
									dispatch(resetFilterSelectedTopics());
									dispatch(setFilterClass(singleClass.klasa));
									dispatch(toggleFilterSections('classes'));
									if (!state.filter.activeSections.includes('subjects')) {
										dispatch(toggleFilterSections('subjects'));
									}
								}}
							/>
						</li>
					))
				) : (
					<li className="dropdown-list-item">Brak</li>
				)}
			</ul>
		</Dropdown>
	);
};

export default Classes;
